<template>
  <b-modal
    id="modalCreateEditSubcategoriaConta"
    size="xl"
    :title="textModal"
    title-class="font-18"
    hide-footer
    no-close-on-backdrop
    @hidden="$emit('closeModal', false)"
  >
    <form @submit.prevent="save">
      <div class="form-row">
        <div class="form-group col-sm-12">
          <label>Descricao: <span class="text-danger">*</span></label>
          <input
            type="text"
            class="form-control"
            :class="{ 'is-invalid': $v.subcategoriaConta.descricao.$error }"
            placeholder="Descrição da categoria de conta"
            v-model="$v.subcategoriaConta.descricao.$model"
          />
          <span
            v-if="!$v.subcategoriaConta.descricao.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
          <span
            v-if="!$v.subcategoriaConta.descricao.minLength"
            class="invalid-feedback"
          >
            A descrição deve possuir pelo menos 3 caracteres
          </span>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group col-sm-4">
          <label>Categorias:</label>
          <select
            class="form-control"
            :class="{
              'is-invalid': $v.subcategoriaConta.categoria_contas_id.$error,
            }"
            v-model="$v.subcategoriaConta.categoria_contas_id.$model"
          >
            <option value="">Selecione uma categoria</option>
            <option
              v-for="categoria in categorias"
              :key="categoria.id"
              :value="categoria.id"
              :title="`${categoria.descricao}`"
            >
              {{ categoria.descricao }}
            </option>
          </select>
          <span
            v-if="!$v.subcategoriaConta.categoria_contas_id.required"
            class="invalid-feedback"
          >
            O campo é obrigatório
          </span>
        </div>
      </div>
      <div v-if="subcategoriaContaId" class="form-row">
        <div class="form-group col-sm-6">
          <p>Status: <span class="text-danger">*</span></p>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusInativo"
              value="0"
              v-model="subcategoriaConta.status"
            />
            <label class="form-check-label" for="statusInativo">
              Inativo
            </label>
          </div>
          <div class="form-check form-check-inline">
            <input
              type="radio"
              class="form-check-input"
              id="statusAtivo"
              value="1"
              v-model="subcategoriaConta.status"
            />
            <label class="form-check-label" for="statusAtivo"> Ativo </label>
          </div>
        </div>
      </div>
      <hr />
      <div class="modal-footer-custom">
        <button
          type="button"
          class="btn btn-secondary"
          title="Cancelar"
          @click="$emit('closeModal', false)"
        >
          Cancelar
        </button>
        <button
          type="submit"
          class="btn btn-primary"
          :title="textModal"
          :disabled="$v.$invalid || disableButton"
        >
          <i
            v-if="disableButton"
            class="spinner-grow spinner-grow-custom text-wither"
          />
          <span v-else>{{ textModal }}</span>
        </button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'

export default {
  name: 'CreateEditSubcategoriaContaModal',
  props: {
    subcategoriaContaId: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      subcategoriaConta: {
        descricao: '',
        categoria_contas_id: '',
      },
      categorias: '',
      disableButton: false,
    }
  },

  computed: {
    textModal() {
      return this.subcategoriaContaId ? 'Atualizar' : 'Cadastrar'
    },
  },

  methods: {
    async getSubcategoriaConta() {
      try {
        this.subcategoriaConta = await this.$store.dispatch(
          'getSubcategoriaConta',
          this.subcategoriaContaId,
        )
        this.$bvModal.show('modalCreateEditSubcategoriaConta')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
        this.$emit('closeModal', false)
      }
    },

    async getCategoriasContas() {
      try {
        this.categorias = await this.$store.dispatch('getCategoriasContas')
      } catch (error) {
        if (error && error.message) {
          this.$root.$bvToast.toast(error.message, {
            title: 'Atenção!',
            variant: 'warning',
            solid: true,
          })
        } else {
          this.$root.$bvToast.toast(
            'Não foi possível se conectar ao servidor.',
            {
              title: 'Erro!',
              variant: 'danger',
              solid: true,
            },
          )
        }
      }
    },

    async save() {
      if (!this.$v.$invalid) {
        this.disableButton = true
        try {
          let response = null
          if (this.subcategoriaContaId) {
            response = await this.$store.dispatch('updateSubcategoriaConta', {
              subcategoriaContaId: this.subcategoriaContaId,
              subcategoriaConta: this.subcategoriaConta,
            })
          } else {
            response = await this.$store.dispatch(
              'saveSubcategoriaConta',
              this.subcategoriaConta,
            )
          }
          this.disableButton = false
          this.$root.$bvToast.toast(response.message, {
            title: 'Sucesso!',
            variant: 'success',
            solid: true,
          })
          this.$emit('closeModal', true)
        } catch (error) {
          this.disableButton = false
          if (error && error.message) {
            this.$root.$bvToast.toast(error.message, {
              title: 'Atenção!',
              variant: 'warning',
              solid: true,
            })
          } else {
            this.$root.$bvToast.toast(
              'Não foi possível se conectar ao servidor.',
              {
                title: 'Erro!',
                variant: 'danger',
                solid: true,
              },
            )
          }
        }
      }
    },
  },

  validations: {
    subcategoriaConta: {
      descricao: {
        required,
        minLength: minLength(3),
      },
      categoria_contas_id: {
        required,
      },
    },
  },

  mounted() {
    this.getCategoriasContas()
    if (this.subcategoriaContaId) {
      this.getSubcategoriaConta()
    } else {
      this.$bvModal.show('modalCreateEditSubcategoriaConta')
    }
  },
}
</script>
